import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Museum {
  id: number;
  name: string;
  museum_code: string;
  description?: string;
  [key: string]: unknown;
}

interface MuseumState {
  selectedMuseum: Museum | null;
}

const initialState: MuseumState = {
  selectedMuseum: null,
};

const museumSlice = createSlice({
  name: 'museum',
  initialState,
  reducers: {
    setSelectedMuseum(state, action: PayloadAction<Museum | null>) {
      state.selectedMuseum = action.payload;
    },
  },
});

export const { setSelectedMuseum } = museumSlice.actions;
export const selectSelectedMuseum = (state: { museum: MuseumState }) => state.museum.selectedMuseum;
export default museumSlice.reducer;
